import { Route, Routes } from 'react-router-dom';
import { React, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Компоненты пользовательского интерфейса
import Preloader from '../CustomElements/Preloader';
import useUrlNavigate from '../../customHook/useUrlNavigate';
import Table from '../Table/Table';
import Modal from '../Modal/Modal';
import CustomButtonDelete from '../CustomElements/CustomButtonDelete';
import CustomButtonEdit from '../CustomElements/CustomButtonEdit';
import { useInfocard, useLoader } from './Common';
import AdjacencyEdit from './AdjacencyEdit';
import ModalDelete from './ModalDelete';
// Кастомные хуки
import { useRole } from '../../customHook/useRole';
// Действия Redux
import { remove } from '../../redux/actions/loader.action';
import { initOptionsSectionFromServer } from '../../redux/actions/options.action';
import { initAdjacencyFromServer } from '../../redux/actions/infocards.action';
import { deleteAdjacencyFromServer } from '../../redux/actions/infocards.action';

// компонент для отображения и управления смежностями на станции

function Adjacency({ t }) {
  const dispatch = useDispatch();

  // роли пользователя
  const isAdmin = useRole('admin');
  let navigate = useUrlNavigate();

  const { stationId, road } = useInfocard();

  const source = useSelector((s) => s.infocards.adjacency);

  const { isLoading } = useLoader();

  useEffect(() => {
    if (Number.isFinite(stationId)) {
      // Запрашиваю элементы для таблицы
      dispatch(initAdjacencyFromServer(stationId));
      // Запрашиваю данные для селектов
      dispatch(initOptionsSectionFromServer(road));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stationId]);

  const columns = useMemo(() => {
    return [
      {
        Header: t?.rc || 'РЦ',
        accessor: 'name',
        Cell: ({ cell: { value } }) => {
          return <span>{value}</span>;
        },
      },
      {
        Header: t?.adjacentRCs || 'Смежные РЦ',
        accessor: 'adjacency',
        Cell: ({ cell: { value } }) => {
          let text = [];
          if (value?.length) {
            for (let adjacency of value) {
              if (stationId !== adjacency?.station) {
                text.push(`${adjacency?.stationName}.${adjacency?.name}`);
              } else {
                text.push(adjacency?.name);
              }
            }
            return <span>{text.join(', ')}</span>;
          } else {
            return 'no';
          }
        },
      },
      isAdmin && {
        Header: t?.actions || 'Действия',
        Cell: ({ row: { original } }) => {
          return (
            <div className="d-flex flex-row flex-nowrap gap-1 justify-content-center">
              {isLoading && <Preloader isLoading />}
              {!isLoading && (
                <>
                  <CustomButtonEdit
                    onClick={() => {
                      navigate((url, root) => {
                        url.pathname = root + `/edit/${original.railChain}`;
                      });
                    }}
                  />
                  <CustomButtonDelete
                    onClick={() => {
                      navigate((url, root) => {
                        url.pathname = root + `/delete/${original.railChain}`;
                      });
                    }}
                  />
                </>
              )}
            </div>
          );
        },
      },
    ].filter(Boolean);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [source, navigate, isAdmin, t]);

  const go2root = useCallback(() => {
    navigate((url, root) => {
      url.pathname = root;
    });
    dispatch(remove());
  }, [navigate, dispatch]);

  const [childParams, setChildParams] = useState({});

  const deletingAdjacency = useMemo(() => {
    const { adjacency } = childParams || {};
    if (!adjacency) {
      return {};
    }

    // eslint-disable-next-line eqeqeq
    let adjObj = source?.find((x) => x.railChain == adjacency);
    if (!adjObj) {
      return {};
    }
    return adjObj?.name;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [childParams]);

  return (
    <div
      className="d-flex flex-column h-100 container-fluid overflow-hidden flex-nowrap"
      style={{ paddingLeft: 'var(--sadr-font-size-12)' }}
    >
      <Table data={source} columns={columns} hiddenDiv={true} />
      <Routes>
        <Route
          path="/edit/:adjacency/*"
          element={
            <Modal isOpen onClose={go2root} containerSelector="#infocard-container">
              <AdjacencyEdit closeModal={go2root} t={t} />
            </Modal>
          }
        />
        <Route
          path="/delete/:adjacency/*"
          element={
            <Modal isOpen onClose={go2root} containerSelector="#infocard-container">
              <ModalDelete
                setParams={setChildParams}
                confirmText={`${
                  t?.confirmDeleteAdjacency || 'Вы уверены, что хотите удалить смежность для'
                } ${deletingAdjacency}?`}
                removalText={`${t?.removalAdjacency || 'Удаление'} ${deletingAdjacency?.prettyName}`}
                successText={t?.successAdjacencyDeleted || 'Смежность была удалена'}
                goBackText={t?.goBackToAdjacencyList || 'К списку смежностей'}
                canDelete={Object.keys(deletingAdjacency).length}
                closeModal={go2root}
                onDelete={() => dispatch(deleteAdjacencyFromServer(stationId, childParams?.adjacency))}
                t={t}
              />
            </Modal>
          }
        />
      </Routes>
    </div>
  );
}
export default Adjacency;
